/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var KonturBonusSignIcon20Solid = forwardRef('KonturBonusSignIcon20Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M11.125 1.5a1.125 1.125 0 0 0-2.25 0v2.375H6.65c-.98 0-1.775.795-1.775 1.775v8.7c0 .98.795 1.775 1.775 1.775h2.225V18.5a1.125 1.125 0 0 0 2.25 0v-2.375h.375a3.625 3.625 0 0 0 0-7.25H7.125v-2.75H13.5a1.125 1.125 0 0 0 0-2.25h-2.375V1.5Zm-4 12.375v-2.75H11.5a1.375 1.375 0 1 1 0 2.75H7.125Z" })));
});
